import * as styles from './ApplyInfo.css';
import SettingContentsList from '@/components/SettingContentsList';
import { useEventUserInfo } from '@/queries/hooks/useEventEnter';
import useApplyEventId from '../../hooks/useApplyEventId';

const ApplyInfo = () => {
  const eventId = useApplyEventId();
  const userInfo = useEventUserInfo(eventId);
  return (
    <div className={styles.container}>
      <SettingContentsList.TitleText
        title="응모 정보"
        optionText={
          <>
            이름 : <b>{userInfo.name}</b>
            {'\n'}선물을 받을 번호 : <b>{userInfo.ctn}</b>
          </>
        }
      />
    </div>
  );
};

export default ApplyInfo;
